import { render, staticRenderFns } from "./PTranslatableTextInput.vue?vue&type=template&id=4f86f676&scoped=true&"
import script from "./PTranslatableTextInput.vue?vue&type=script&lang=js&"
export * from "./PTranslatableTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f86f676",
  null
  
)

export default component.exports